/* assets/src/viewer/perf/disposal.js
 * Dispose disciplinato (port :603-620): libera geometrie e materiali del gruppo,
 * ma MAI le texture condivise (userData.asgShared). Usato solo su cambio modelType.
 */
const SHARED_MAPS = ['map', 'bumpMap', 'normalMap', 'roughnessMap', 'metalnessMap', 'alphaMap', 'aoMap', 'emissiveMap', 'sheenColorMap'];

export function disposeGroup(group) {
  if (!group) return;
  group.traverse((child) => {
    if (child.geometry && child.geometry.dispose) child.geometry.dispose();
    if (child.material) {
      const materials = Array.isArray(child.material) ? child.material : [child.material];
      materials.forEach((mat) => {
        if (!mat) return;
        SHARED_MAPS.forEach((key) => {
          const tex = mat[key];
          if (tex && tex.dispose && !(tex.userData && tex.userData.asgShared)) tex.dispose();
        });
        if (mat.dispose) mat.dispose();
      });
    }
  });
}
